import { matchPath } from 'react-router-dom';

const APP_NAME = 'Revvly';

// Most specific first: the first matching pattern wins. Detail routes carry the
// section name so a tab in the browser history says where you were.
const ROUTE_TITLES: Array<[pattern: string, title: string]> = [
  ['/select-tenant', 'Select workspace'],
  ['/no-access', 'No access'],
  ['/login', 'Sign in'],
  ['/oauth/consent', 'Authorize access'],
  ['/signup/confirm', 'Finish signup'],
  ['/signup', 'Start free trial'],
  ['/forgot-password', 'Forgot password'],
  ['/reset-password', 'Reset password'],
  ['/verify-email-change', 'Verify email change'],
  ['/accept-invite', 'Accept invitation'],
  ['/join/:token', 'Join workspace'],
  ['/f/r/:token', 'Form'],
  ['/f/:publicId', 'Form'],
  ['/onboarding', 'Onboarding'],
  ['/', 'Assistant'],
  ['/assistant', 'Assistant'],
  ['/account', 'Account'],
  ['/whats-new', "What's new"],
  ['/users/export', 'Export users'],
  ['/users', 'Users'],
  ['/dashboard', 'Dashboard'],
  ['/tasks', 'Tasks'],
  ['/situations', 'Situations'],
  ['/library', 'Library'],
  ['/work-queue', 'Work queue'],
  ['/inbox/settings', 'Inbox settings'],
  ['/inbox', 'Inbox'],
  ['/companies', 'Companies'],
  ['/contacts', 'Contacts'],
  ['/pipeline/forecast', 'Forecast'],
  ['/pipeline/stages', 'Pipeline stages'],
  ['/pipeline', 'Pipeline'],
  ['/forms/:id/:tab?', 'Form'],
  ['/forms', 'Forms'],
  ['/clients/workload', 'CSM workload'],
  ['/clients/:id/:tab?', 'Client'],
  ['/clients', 'Clients'],
  ['/subscriptions/*', 'Subscriptions'],
  ['/product-config/*', 'Product configuration'],
  ['/market-config', 'Markets'],
  ['/catalog/modules/*', 'Modules'],
  ['/catalog/bundles/*', 'Bundles'],
  ['/catalog/components/*', 'Components'],
  ['/catalog/learning', 'Catalog learning'],
  ['/catalog', 'Catalog'],
  ['/discounts', 'Discounts'],
  ['/settings/tax/rates/:id', 'Tax rate'],
  ['/settings/meters/:id', 'Meter'],
  ['/settings/slack/mapping', 'Slack mapping'],
  ['/settings/slack/invite', 'Slack invite'],
  ['/settings/slack/invites', 'Slack invites'],
  ['/settings/*', 'Settings'],
  ['/settings', 'Settings'],
  ['/renewals', 'Renewals'],
  ['/finance', 'Finance'],
  ['/usage/bulk-entry', 'Bulk usage entry'],
  ['/invoices/new', 'New invoice'],
  ['/invoices/:id', 'Invoice'],
  ['/okr/objectives/*', 'Objective'],
  ['/okr/key-results/*', 'Key result'],
  ['/okr/kr/:id', 'Key result'],
  ['/okr/teams/:id', 'Team OKRs'],
  ['/okr/hypotheses/learnings', 'Learnings'],
  ['/okr/hypotheses/:id', 'Hypothesis'],
  ['/okr/hypotheses', 'Hypotheses'],
  ['/okr/coverage', 'Coverage'],
  ['/okr', 'OKRs'],
  ['/my-okrs', 'My OKRs'],
  ['/support/tickets/:number', 'Ticket'],
  ['/support/end-users/:id', 'Person'],
  ['/support/end-users', 'People'],
  ['/support/knowledge', 'Knowledge'],
  ['/support/guidelines', 'Guidelines'],
  ['/support/metrics', 'Support metrics'],
  ['/support/compare', 'Compare'],
  ['/support/notifications', 'Support notifications'],
  ['/support/sandbox', 'Sandbox'],
  ['/support', 'Support'],
  ['/import/crm', 'Import CRM'],
  ['/import/transactions', 'Import transactions'],
  ['/import/subscriptions', 'Import subscriptions'],
  ['/import/spot-check', 'Spot check'],
  ['/import/sync-results/:jobId/review', 'Review sync'],
  ['/import/sync-results/:jobId/spot-check', 'Spot check'],
  ['/import/sync-results/:jobId/summary', 'Sync summary'],
  ['/import/sync-results/:jobId', 'Sync results'],
  ['/import', 'Import'],
];

export function titleForPath(pathname: string): string {
  for (const [pattern, title] of ROUTE_TITLES) {
    if (matchPath({ path: pattern, end: true }, pathname)) {
      return `${title} · ${APP_NAME}`;
    }
  }
  return APP_NAME;
}
